// extracted by mini-css-extract-plugin
module.exports = {"graph":"GoldGraph_graph__3Lbr7","graph-header":"GoldGraph_graph-header__2M-EB","graph-header__sell":"GoldGraph_graph-header__sell__103EW","arrow":"GoldGraph_arrow__Y0Aru"};